module.exports = __webpack_public_path__ + "static/media/my-account.0a78b59b.svg";